import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

import { Role } from '@models/roles.enum';

/**
 * Guard class for allowing access only for users with the {@link Role} of atom operator
 */
@Injectable()
export class MilkrunGuard implements CanActivate {

    constructor(private router: Router, private authenticationService: AuthenticationService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authenticationService.isCurrentUserWithRole(Role.MILKRUN_OPERATOR)) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
